if (!customElements.get('featured-festive-bundle')) {
  customElements.define(
    'featured-festive-bundle',
    class FeaturedFestiveBundle extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.checkbox = this.querySelector('.festive-bundle__checkbox');
        this.note = this.querySelector('[data-festive-bundle-note]');
        this.modal = document.getElementById(this.dataset.modalId);
        this.modalCta = this.modal?.querySelector('[data-festive-bundle-cta]');
        this.video = this.modal?.querySelector('video');
        this.opener = this.querySelector('.festive-bundle__see-inside');

        if (!this.checkbox) return;

        this.checkbox.addEventListener('change', () => this.syncState());
        this.modalCta?.addEventListener('click', () => this.toggleFromModal());
        this.opener?.addEventListener('click', () => this.playVideoAfterOpen());
        this.syncState();
      }

      syncState() {
        const isSelected = this.checkbox.checked;
        this.classList.toggle('is-selected', isSelected);

        if (this.note) this.note.hidden = !isSelected;
        if (!this.modalCta || this.modalCta.disabled) return;

        this.modalCta.setAttribute('aria-pressed', isSelected.toString());
        this.modalCta.textContent = isSelected ? this.modalCta.dataset.addedLabel : this.modalCta.dataset.addLabel;
      }

      toggleFromModal() {
        if (this.checkbox.disabled) return;

        this.checkbox.checked = !this.checkbox.checked;
        this.checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }

      playVideoAfterOpen() {
        if (!this.video) return;

        requestAnimationFrame(() => {
          this.video.muted = true;
          const playRequest = this.video.play();
          if (playRequest) playRequest.catch(() => {});
        });
      }
    }
  );
}
